import { createSlice } from '@reduxjs/toolkit';
import {
  GET_USERS_DATA,
  DELETE_USER,
  SEND_CONFIRMATION_REMINDER,
  USER_UPDATED
} from '../constants/constants';

const initialState = {
  remindersSent: false,
  data: [],
  loaded: false,
  plans: {},
  subscriptionStatuses: {},
  totalPages: 1
};

const applyUserUpdate = (state, user) => {
  state.data.forEach(item => {
    if (item.email === user.email) {
      item.account_type = user.account;
      if ('manual_plan' in user) item.manual_plan = user.manual_plan;
    }
  });
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    userUpdated: (state, action) => applyUserUpdate(state, action.payload)
  },
  extraReducers: builder => {
    builder
      .addCase(SEND_CONFIRMATION_REMINDER, (state, action) => {
        state.remindersSent = action.data.success;
      })
      .addCase(GET_USERS_DATA, (state, action) => {
        state.data = action.data.data;
        state.loaded = true;
        state.plans = action.data.plans || state.plans;
        state.subscriptionStatuses = action.data.subscription_statuses || state.subscriptionStatuses;
        state.totalPages = action.data.total_pages;
      })
      .addCase(DELETE_USER, (state, action) => {
        state.data = state.data.filter(item => action.data._id.$oid !== item._id.$oid);
      })
      .addCase(USER_UPDATED, (state, action) => applyUserUpdate(state, action.data));
  }
});

export const { userUpdated } = usersSlice.actions;
export default usersSlice.reducer;
